/** Exit-intent popup placements — shared by the modal and Admin → Promotions. */
export const EXIT_PLACEMENTS = [
  { key: 'landing', label: 'Home page', who: 'Visitors & free students', how: 'Mouse leaves at the top · 30 s idle · sharp scroll-up on phones', passive: true },
  { key: 'pricing', label: 'Pricing page', who: 'Visitors & free students', how: 'Same triggers as the home page', passive: true },
  { key: 'dashboard', label: 'Dashboard', who: 'Free students', how: 'Same triggers — while they browse the dashboard after signing in', passive: true },
  { key: 'test_done', label: 'Test finished', who: 'Free students', how: 'Results page, 3 s after a test they just finished loads' },
  { key: 'test_exit', label: 'Test left midway', who: 'Free students', how: 'Right after they confirm "Exit Exam" in the test player' },
  { key: 'course_done', label: 'Course finished', who: 'Free students', how: 'The moment the last section of a course is marked complete' },
];

export const PASSIVE_PLACEMENT_BY_PATH = { '/': 'landing', '/pricing': 'pricing', '/dashboard': 'dashboard' };

export const placementOn = (cfg, key) => !!cfg && (cfg.exit_placements || {})[key] !== false;

/** Fire a "moment" trigger (test finished / left / course finished). */
export function triggerExitIntent(placement, delayMs = 0) {
  window.dispatchEvent(new CustomEvent('cmx:exit-intent', { detail: { placement, delayMs } }));
}
